import { createContext } from 'react'

/** 재료 편집 창 — 창 머리 · 단계 알약이 이미 이름을 보여 주므로 본문의 단계 제목을 그리지 않는다 */
export const StepTitleHidden = createContext(false)
